var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-menu',{attrs:{"router":true,"default-active":_vm.$route.meta.parentPath,"active-text-color":"#FFFFFF","unique-opened":true}},_vm._l((_vm.userMenu),function(item1,index){return _c('tree-menu',{key:index,attrs:{"item":item1}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }